module.exports = __webpack_public_path__ + "static/media/landing-2-shape.6288675a.svg";